import Content from '@layout/Content'
import OneWaySlabForm from './OneWaySlabForm'
import OneWaySlabResult from './OneWaySlabResult'
import { OneWaySlabProvider } from './context'

function OneWaySlabPage () {
  return (
    <OneWaySlabProvider>
      <Content
        renderInput={<OneWaySlabForm />}
        renderOutput={<OneWaySlabResult />}
      />
    </OneWaySlabProvider>
  )
}

export default OneWaySlabPage
